/** @file thumbnailOf: a slot's tile cut out of the preview bundle's decoded sheet (null when not drawn). */
import type { Image } from '@zilo/pose3d-image-io/types/image';
import { cropImage } from '@zilo/pose3d-image-io/image/cropImage';
import type { LoadedBundle } from '@zilo/pose3d-runtime-babylon/bundle/loadedBundle';

/** The slot address a thumbnail is cut for. */
type SlotAddress = { drawable: string; entry: number; tile: number };

/**
 * `rects[tile]` of entry `entry` of impostor `drawable`, cropped from the sheet the entry names (`sheetNames` gives
 * its index in `sheets`); null without a bundle, for an empty rect, an unknown drawable or a missing sheet.
 */
export function thumbnailOf(bundle: LoadedBundle | null, slot: SlotAddress): Image | null {
  const d = bundle?.puppet.drawables.find((x) => x.id === slot.drawable);
  if (bundle === null || d?.kind !== 'impostor') return null;
  const entry = d.facets[slot.entry];
  const rect = entry?.rects[slot.tile] ?? null;
  if (entry === undefined || rect === null) return null;
  const sheet = bundle.sheets[bundle.sheetNames.indexOf(entry.sheet)];
  if (sheet === undefined) return null;
  return cropImage(sheet, rect[0], rect[1], rect[2], rect[3]);
}
